import React, { useState, useEffect } from 'react'
import { Container, Row, Col } from "reactstrap"
import { Route, Routes } from 'react-router-dom'
import AutomatelyListHeader from "./AutomatelyListHeader"
import AutomationList from "./AutomationList"
import WorkflowBuilder from "./WorkflowBuilder/WorkflowBuilder"

export default function AutomatelyContainer(props) {

    return (
        <div className="AutomatelyContainer">
            <Routes>
                <Route path="/new" element={<WorkflowBuilder />} />
                <Route path="/:id" element={<WorkflowBuilder />} />
                <Route path="/" element={<AllAutomations client={props?.client} />} />
            </Routes>

        </div>

    )
}

const AllAutomations = (props) => {
    const [filterValues, setFilterValues] = useState(() => {
        // Retrieve filters from localStorage, if they exist
        const savedFilters = localStorage.getItem('AutomationContainerFilters')
        return savedFilters ? JSON.parse(savedFilters) : { searchTerm: "" }
    })
    const [selectedIds, setSelectedIds] = useState([])

    useEffect(() => {
        // Save filters to localStorage whenever they change
        localStorage.setItem('AutomationContainerFilters', JSON.stringify(filterValues))
    }, [filterValues])
    return (
        <Container fluid>
            <AutomatelyListHeader
                activeTab="all"
                filterValues={filterValues}
                setFilterValues={(res) => setFilterValues({ ...res })}
                selectedIds={selectedIds}
                resetSelectedIds={() => setSelectedIds([])}
                client={props?.client}
            />
            <Row>
                <Col>
                    <AutomationList {...filterValues} />
                </Col>
            </Row>
        </Container>
    )
}
